export function shortifyText(length, text, moreButton = false) {
    var string;
    if (text.length > length) {
        if (moreButton) string = text.substr(0, length - 3) + ".....   View More"
        else string = text.substr(0, length - 3) + "... "
        return string
    }
    return text
}
export function openInNewTab(url) {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}

export function checkElementInArray(array, key, value) {
    return array.some(function (el){
        return el[key] === value
    })
}

export function convertTime12To24(time) {
    var hours   = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM    = time.match(/\s(.*)$/)[1];
    if (AMPM === "PM" && hours < 12) hours = hours + 12;
    if (AMPM === "AM" && hours === 12) hours = hours - 12;
    var sHours   = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return (sHours + ":" + sMinutes);
}

export function removeElementFromArray(array, key, value){
    if(checkElementInArray(array, key, value)){
        var index = array.findIndex(element => element[key] === value) 
        if(index !== -1) array.splice(index, 1)
        return array
    }
}